/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ColorDictionaryDtoFromJSON(json) {
    return ColorDictionaryDtoFromJSONTyped(json, false);
}
export function ColorDictionaryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'colorDictionaryId': !exists(json, 'colorDictionaryId') ? undefined : json['colorDictionaryId'],
        'colorName': !exists(json, 'colorName') ? undefined : json['colorName'],
    };
}
export function ColorDictionaryDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'colorDictionaryId': value.colorDictionaryId,
        'colorName': value.colorName,
    };
}
